export const en = {
  PROJECt_MANAGER: "PROJECT MANAGER",
  NADA_AHMED: "NADA AHMED",
};

export const ar = {
  PROJECt_MANAGER: "مدير المشروع",
  NADA_AHMED: "ندى أحمد",
};
